// extracted by mini-css-extract-plugin
export default {"divider":"Supplements_divider__wjx-b","upsellDivider":"Supplements_upsellDivider__Ytx-9"};